/**
 * Purpose: Centralize selectable forecast-domain metadata and Open-Meteo grid bindings.
 * Assumptions: Each configured domain path exists in weather-map-layer domainOptions.
 * External refs: src/external/weather-map-layer (vendored @openmeteo/weather-map-layer@0.0.19) domainOptions/GridData definitions.
 */
import { domainOptions, type GridData } from "@openmeteo/weather-map-layer";

export type ForecastDomain = {
  id: string;
  label: string;
  path: string;
  center: [number, number];
  zoom: number;
  grid: GridData;
};

function getGridForDomain(domainPath: string): GridData {
  const domain = domainOptions.find((option) => option.value === domainPath);
  if (!domain) {
    throw new Error(`Open-Meteo domain "${domainPath}" is not available`);
  }

  return domain.grid;
}

export const FORECAST_DOMAINS: ForecastDomain[] = [
  {
    id: "cmc_gem_hrdps_west",
    label: "GEM HRDPS West",
    path: "cmc_gem_hrdps_west",
    center: [-123.5, 53.4],
    zoom: 4.2,
    grid: getGridForDomain("cmc_gem_hrdps_west"),
  },
  {
    id: "ncep_hrrr_conus",
    label: "NOAA HRRR CONUS",
    path: "ncep_hrrr_conus",
    center: [-98.6, 39.5],
    zoom: 3.3,
    grid: getGridForDomain("ncep_hrrr_conus"),
  },
  {
    id: "meteofrance_arome_france_hd",
    label: "Météo-France AROME France HD",
    path: "meteofrance_arome_france_hd",
    center: [2.2, 46.4],
    zoom: 5.1,
    grid: getGridForDomain("meteofrance_arome_france_hd"),
  },
  {
    id: "dwd_icon_d2",
    label: "DWD ICON-D2 Germany",
    path: "dwd_icon_d2",
    center: [10.5, 51.2],
    zoom: 5.2,
    grid: getGridForDomain("dwd_icon_d2"),
  },
];

export function getForecastDomainById(domainId: string): ForecastDomain {
  const domain = FORECAST_DOMAINS.find(
    (candidate) => candidate.id === domainId,
  );
  if (!domain) {
    throw new Error(`Forecast domain "${domainId}" is not configured`);
  }

  return domain;
}
